<!--
 * @Author: john 285342894@qq.com
 * @Date: 2023-07-19 22:21:15
 * @LastEditors: john 285342894@qq.com
 * @LastEditTime: 2023-12-19 16:06:07
 * @FilePath: \horse\src\components\upload\select.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div :style="style">
            <a-button type="primary" ghost icon="plus" :isPrivate="isPrivate" :btnText="btnText" :isSingle="isSingle" @click="select()">{{btnText}}</a-button>
        </div>
        <div class="file-list">
            <div v-for="(item,index) in filePathList" :key="index" class="file-item">
                <template>
                    <template v-if="item.file_type=='image' && !item.is_private">
                        <img :src="item.file_path" />
                        <div class="show-action">
                            <div class="flex space alcenter">
                                <a-icon @click="showImg(item)" type="eye" />
                                <a-icon @click="delFile(index)" style="margin-left: 15px;" type="delete" />
                            </div>
                        </div>
                    </template>
                    <template v-if="item.file_type=='video' && !item.is_private">
                        <video width="100%" height="100%"  style="object-fit: cover;">
                            <source :src="item.file_path" type="video/mp4" >
                        </video>
                        <div class="show-action">
                           <div class="flex space alcenter">
                                <a target="_blank" :href="item.file_path"><a-icon  type="eye" /></a>
                                <a-icon @click="delFile(index)" style="margin-left: 15px;" type="delete" />
                            </div>
                        </div>
                    </template>
                    <template v-if="item.file_type=='image' && item.is_private">
						<a-icon class="font-icon" type="file-image" />
                    </template>
                    <template v-if="item.file_type=='video' && item.is_private">
						<a-icon class="font-icon" type="video-camera" />
                    </template>
                    <template v-if="item.file_type=='file'">
                        <a-icon v-if="item.extension.toLowerCase() =='docx'" class="font-icon" type="file-word" />
                        <a-icon v-if="item.extension.toLowerCase() =='doc'" class="font-icon" type="file-word" />
                        <a-icon v-if="item.extension.toLowerCase() =='pdf'" class="font-icon" type="file-pdf" />
                        <a-icon v-if="item.extension.toLowerCase() =='zip'" class="font-icon" type="file-zip" />
                        <a-icon v-if="item.extension.toLowerCase() =='rar'" class="font-icon" type="file-zip" />
                        <a-icon v-if="item.extension.toLowerCase() =='xls'" class="font-icon" type="file-excel" />
                        <a-icon v-if="item.extension.toLowerCase() =='xlsx'" class="font-icon" type="file-excel" />
                        <a-icon v-if="item.extension.toLowerCase() =='csv'" class="font-icon" type="file-excel" />
                        <a-icon v-if="item.extension.toLowerCase() =='ppt'" class="font-icon" type="file-ppt" />
                        <a-icon v-if="item.extension.toLowerCase() =='pptx'" class="font-icon" type="file-ppt" />
                        <div class="show-action">
                            <a-icon v-if="item.extension.toLowerCase() =='docx'" @click.stop="previewFile(item)" type="file-word" />
                            <a-icon v-if="item.extension.toLowerCase() =='doc'" @click.stop="previewFile(item)"  type="file-word" />
                            <a-icon v-if="item.extension.toLowerCase() =='pdf'" @click.stop="previewPdf(item)"  type="file-pdf" />
                            <a-icon @click="delFile(index)" style="margin-left: 15px;" type="delete" />
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <div v-if="selectLoading">
            <file-list :filePathList="filePathList" :isSingle="isSingle" :isPrivate="isPrivate" :visible="selectLoading" @cancel="cancel" @ok="ok"></file-list>
        </div>
        <a-modal :title="null" v-model="isShowImg" :footer="null">
			<img style="width: 100%;" :src="selectPath" />
		</a-modal>
    </div>
</template>

<script>
import fileList from './modal/fileList.vue';
export default {
    components: { 
        fileList,
    },
    props:{
        value:{
            type: Array,
            default: function(){
                return [];
            },
        },
        isSingle:{
            type: Boolean,
            default: false,
        },
        //是否私有化文件上传
        isPrivate: {
            type: Boolean,
            default: false
        },
        btnText:{
            type: String,
            default: '选择图片',
        },
        style:{
            type: JSON,
            default: {},
        },
    },
    created(){
        console.log(this.btnText);
    },
    computed:{
        filePathList() {
            return this.value;
        }
    },
    data(){
        return {
            isDocShow: false,
            docxPath: '',
            isPdfShow: false,
            pdfPath: '',
            loading: false,
            fileList: [],
            selectLoading: false,
            isShowImg: false,
            selectPath: '',
        }
    },
    methods:{
        previewFile(item){
            let {href} = this.$router.resolve('/preview?file_type='+item.extension.toLowerCase()+'&file_path=' + item.file_path);
            window.open(href, '_blank');
        },
        previewPdf(item){
            window.open(item.file_path, '_blank');
        },
        FileType(ext){
            let typeList = ['pdf','doc','docx'];
            return typeList.indexOf(ext.toLowerCase()) > -1 ? true : false;
        },
        select() {
            this.filePathList = [];
			this.selectLoading = true;
        },
        showImg(item){
            this.selectPath=item.file_path;
            this.isShowImg = true;
        },
        delFile(index){
            this.filePathList.splice(index, 1);
        },
        cancel(){
            this.selectLoading=false;
        },
        ok(data){
            this.selectLoading=false;
            if(data.length>0){
                this.value = this.isSingle ? [data[0]] : data;
                //console.log(this.filePathList);
                this.$emit('input', this.value);
            }
        },
    },
}
</script>

<style>
    .select-file-btn{
        width: 120px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid #5333FF;
    }
    .file-list{ margin-top:10px; display: flex; flex-wrap:wrap;}
    .file-item{
        position: relative;
        margin-right:8px;
        margin-bottom:8px;
        width:128px; 
        height:128px; 
        background-color:rgba(94,64,255,.06); 
        border:1px dashed #d9d9d9;
        border-radius:2px;
        padding:8px;
        box-sizing: border-box;
        display: flex;
        align-items:center;
        justify-content:center;

    }
    .file-item img{ 
        width:110px; 
        height:110px;
        object-fit: cover;
    }
    .file-item .file-icon{bottom:0px; right:0px; width:30px; height:30px; line-height:30px; text-align:center;background-color:rgba(0,0,0,0.6);border-top-left-radius:5px;  position: absolute;}
    .file-item .file-icon .anticon{color:#fff;}
    .file-item .font-icon{font-size:80px; color:rgba(0,0,0,0.35);}
    .file-item .show-action {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.3);
		opacity: 0;
		transition: opacity 0.3s;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 24px;
	}

	.file-item:hover .show-action {
		opacity: 1;
	}

	.file-item:hover {
		border-color: #4772FF;
	}
    
</style>